let welcome_jars = document.querySelectorAll('.welcome-jars .welcome-jar') || false; 
let welcome_jars_containers =  document.querySelectorAll ('.jars-container');
let bundle_product = welcome_jars_containers.length > 1 ? true : false;

const calcMaxQuantity = () => {
  let jarsLimits = JSON.parse(document.getElementById('bundle-jars-limits').textContent);
  let currentVariantId = document.querySelector('#main-prodct-form [name="id"]').value;
  let jarsMaxQty;

  for (const [key, value] of Object.entries(jarsLimits)) {
    if (key == currentVariantId) jarsMaxQty = value;
  }

  return jarsMaxQty;
}


const toggleGalleryJar = jar_id => {
  let gallery_jar_imgs = document.querySelectorAll('.welcome-jar__image');

  gallery_jar_imgs.forEach(el => {
    el.dataset.variantId == jar_id ? el.classList.add('active') : el.classList.remove('active');
  });
}

const toggleActiveJar = event => {
  let targetJar = event.target.closest('.welcome-jar');
  let jarParent = targetJar.closest('.welcome-jars');

  jarParent.querySelector('.welcome-jar.active').classList.remove('active');
  targetJar.classList.add('active');
  getSelectedJar();
}

const getSelectedJar = () => {
  let jars = [];
  let curent_jar = document.querySelector('.welcome-jar.active');

  if (!bundle_product) {
    if (curent_jar.dataset.variantId != undefined) {
      jars.push(curent_jar.dataset.variantId);
    }
  
    toggleGalleryJar(jars[0]);
  }else {
    document.querySelectorAll('.jars-container:not(.hidden)').forEach(el => {
      jars.push(el.querySelector('.welcome-jar.active').dataset.variantId);
    });
  }

  updateWelcomekitProperty(jars);
}

const updateWelcomekitProperty = (jars) => {
    let product_form = document.querySelector('#main-prodct-form .product-form form');
    if (product_form.querySelector('#welcome_kit')) product_form.querySelector('#welcome_kit').remove()
    if (!jars) return;


    if (jars && product_form) {
      product_form.insertAdjacentHTML('afterbegin', `<input id="welcome_kit" type="hidden" name="properties[_welcome_kit]" value="${jars.join(',')}">`);
    }
}

welcome_jars.length > 0 && welcome_jars.forEach(jar => jar.addEventListener('click', toggleActiveJar));

if (bundle_product) {
  document.body.addEventListener('productVariantUpdated', () => {
    let maxQty = calcMaxQuantity();

    welcome_jars_containers.forEach((container, index) => {
      index < maxQty ? container.classList.remove('hidden') : container.classList.add('hidden');
    });

    getSelectedJar();
  });
}